import { useRef } from "react";
import { generatePushID } from "./generate-pushid";

export const usePushID = () => {
  const ref = useRef(generatePushID());
  return ref.current;
};
